import { CommonModule } from '@angular/common';
import { CustomizeDateTimePickerComponent } from './customize-date-time-picker.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

@NgModule({
    declarations: [CustomizeDateTimePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        NzDatePickerModule,
    ],
    exports: [CustomizeDateTimePickerComponent],
})
export class CustomizeDateTimePickerModule {}
